import { useOtherLocale, useOtherLocaleUrl } from '@dreamstack/i18n'
import { cn } from '@dreamstack/util/src/cn'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
// linkHoverStyles equivalent: group-hover:border-accentroWhite-full + hover:border-current

export const LocaleSwitcher: FunctionComponent<
  React.PropsWithChildren<{}>
> = () => {
  const otherLocale = useOtherLocale()
  const slugInOtherLocale = useOtherLocaleUrl()

  if (!slugInOtherLocale || !otherLocale) return null

  const prefix = !slugInOtherLocale.startsWith('/') ? '/' : ''
  const href = `${prefix}${slugInOtherLocale}`

  return (
    <>
      {/* TODO: find out "/" at the start of path href={`/${slugInOtherLocale}`} */}
      <Link
        href={href}
        locale={otherLocale}
        passHref
        className={cn(
          'rounded-none cursor-pointer inline-block border-b-2 border-b-transparent font-semibold z-10',
          // Active style (border-b-2 + border-color: currentColor) applied on hover/active/focus
          'hover:border-current',
          // Group hover behavior from original linkHoverStyles
          'group-hover:border-accentroWhite-full'
        )}
      >
        {otherLocale.toUpperCase()}
      </Link>
    </>
  )
}
